import classNames from 'classnames'
import React, { useState } from 'react'

import { Intent } from '../../config/intent'
import { AuthHeading } from '../authentication/auth-heading'
import { Button } from '../button'
import { VerificationCodeInput } from '../verification-code-input'

type HTMLInputProps = React.InputHTMLAttributes<HTMLInputElement>

export interface VerifyTwoFAInputProps extends HTMLInputProps {
    /** Input type, defaults to 'text' */
    type: 'email' | 'phone_number'
    /** Function to confirm the code */
    confirmCode: (type: 'email' | 'phone_number', code: string) => void
    /** Function to resend code */
    resendCode: () => void
    newValue: string
    error: string | null
}

export const INPUT_CLASSES = {
    wrapper: [
        'flex border rounded-md',
        'focus-within:outline-none focus-within:ring focus-within:ring-black focus-within:shadow-md',
    ],
    input: [
        'px-9 py-5 border-0 w-full',
        'bg-white bg-opacity-0',
        'focus:outline-none',
    ],
}
interface TextTypes {
    email: (email: string) => React.ReactChild
    phone_number: (phone: string) => React.ReactChild
}
const TEXTS = {
    email: (email: string) => (
        <p>
            We sent a code to your new email <u>{email}</u>
        </p>
    ),
    phone_number: (phone: string) => (
        <p>
            We sent a code to your new phone number ending in{' '}
            <u>{phone.substr(phone.length - 4, phone.length - 1)}</u>
        </p>
    ),
}

export function VerifyTwoFAInput({
    type,
    resendCode,
    confirmCode,
    newValue,
    error,
}: VerifyTwoFAInputProps) {
    const [value, setValue] = useState('')
    const wrapperClasses = classNames(
        'p-24 pt-12 flex flex-col flex-grow sm:p-12 h-full',
    )

    return (
        <div className={wrapperClasses}>
            <div className={'border-b border-gray2 pb-4'}>
                <h4 className='text-thin'>Personal information</h4>
            </div>

            <div className={'mt-8'}>
                <AuthHeading
                    heading={'Enter 2FA 6-digit code'}
                    subHeading={TEXTS[type as keyof TextTypes](newValue)}
                />
            </div>
            <VerificationCodeInput
                name='2fa'
                onChange={(text: string) => setValue(text)}
                intent={error ? Intent.DANGER : Intent.DEFAULT}
            />

            <p className='mt-8 font-light'>
                Didn't get the code,{' '}
                <span
                    className='font-normal text-black cursor-pointer'
                    onClick={resendCode}>
                    <u> click here to resend</u>
                </span>
            </p>
            <Button
                onClick={() => confirmCode(type, value || '')}
                className='mt-4'>
                Confirm
            </Button>
        </div>
    )
}
